import React, { useEffect, useMemo, useState } from "react";
import _ from "lodash";

import { formatAddress } from "../../../utils/common-utils";
import { formDataFields } from "../formData";
import { formProfileData } from "../hooks/info-form-helper";
import { addressFormData, profileToFormValues } from "../hooks/use-helpers";
import useProfile from "../../../features/profile/useProfile";
import { isStubProfile } from "../../../features/profile/profileStore";
import ConsumerAddress from "./Address";

import ProfileInfo from "./ProfileInfo";

import "../styles.css";
import "../theme.css";

const Info = () => {
  const { profile, fetchProfile } = useProfile();

  const [addressView, setAddressView] = useState(false);
  const [draftFields, setDraftFields] = useState(null);
  const [addressDetails, setAddressDetails] = useState({});

  const submitted = !isStubProfile(profile);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  useEffect(() => {
    setAddressDetails(addressFormData(profile.address));
  }, [profile]);

  const seededFields = useMemo(() => {
    const { fields } = formDataFields(submitted)["info"];

    return formProfileData(fields, profileToFormValues(profile));
  }, [profile, submitted]);

  const profileDetails = draftFields || seededFields;

  const toggleView = () => {
    setAddressView((prev) => !prev);
  };

  const onSaveAddress = (address) => {
    setAddressDetails(address);
    toggleView();
  };

  return (
    <div className="profile-page full-bleed">
      {!addressView ? (
        <ProfileInfo
          showAddressView={toggleView}
          addressDetails={addressDetails}
          addressLiner={
            !_.isEmpty(addressDetails) && {
              address: formatAddress(addressDetails),
            }
          }
          profileDetails={profileDetails}
          onDraftChange={setDraftFields}
          submitted={submitted}
        />
      ) : (
        <ConsumerAddress
          onSave={onSaveAddress}
          showProfileView={toggleView}
          addressDetails={addressDetails}
          onBack={toggleView}
          submitted={submitted}
        />
      )}
    </div>
  );
};

export default Info;
